module.exports = __webpack_public_path__ + "img/login-h5bg.2d84e884.png";